import CollectionGallery from "./CollectionGallery";
import { useParams } from "react-router-dom";
import Collection from "./Collection";

const HomepageCollections = () => {

    const { code } = useParams();


    return (
        <>
            {code ? 
                <Collection code={code} />
            :
                <CollectionGallery />
            }
        </>
    );
}


export default HomepageCollections;